import React, { useMemo } from 'react';
import { DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { useCustomWidths, useWidthObserver } from 'app/components/resize-hooks';
import { DashboardCell } from 'app/area/dashboard/dashboard-cell';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { usePrint } from './use-print';
import { DashboardFavouriteLayout } from './types-store';
import styles from './dashboard.scss';

interface DashboardLayoutProps {
  mainFavouriteId: number;
  reportApiOverrides: Partial<ReportCommonApi>;
  executionCounter: number;
  dashboardFavourites: DashboardFavouriteLayout[];
  drillDown: DrillDownCallback;
}
export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  mainFavouriteId,
  reportApiOverrides,
  executionCounter,
  dashboardFavourites,
  drillDown
}) => {

  const widthItems = useMemo(() =>
    [...dashboardFavourites]
      ?.sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))
      ?.map(favouriteModel => ({
        id: favouriteModel.favourite,
        width: favouriteModel.minWidth
      })), [dashboardFavourites]);

  const { width, ref: observedRef, forceUpdate } = useWidthObserver<HTMLDivElement>();
  const { minWidths, requestCustomWidth } = useCustomWidths(widthItems, width || 500);
  usePrint(observedRef, forceUpdate);

  return <div className={styles.favouritesLayoutExpander}>
    <div ref={observedRef} className={`favourites-layout ${styles.favouritesLayout}`}>
      {minWidths.map(savedReportWidth => {

        const favouriteModel = dashboardFavourites.find(
          favourite => savedReportWidth.id === favourite.favourite
        );

        return favouriteModel
          ? <DashboardCell
            key={`fav${mainFavouriteId}_${favouriteModel.id}`}
            reportApiOverrides={reportApiOverrides}
            executionCounter={executionCounter}
            favouriteModel={favouriteModel}
            containerWidth={savedReportWidth?.width}
            drillDown={drillDown}
            requestCustomWidth={requestCustomWidth}
          />
          : null;
      })}
    </div>
  </div>;
};
